export const TITLE = 'Saved Search';
export const MANAGE_LIST = 'Manage List';